import {
  Box,
  Container,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React from "react";
import { icons, images, videos } from "../../assets";
import { allColors } from "../../constants";
import GlobalButton from "./../../components/globalButton/index";
import { mediaUrl } from "../../constants/variables";
// import ReactPlayer from "react-player";

// Features data with tick icons
// const featuresData = [
//   {
//     title:"",
//     description:""
//   }
//   "Fastest-growing B2B utility provider.",
//   "Proud partnerships with Cashflows and EIT.",
//   "Access to leading card payment operators.",
//   "Offer tailored card machine solutions.",
//   // "Solutions for startups and established businesses.",
//   // "Bespoke packages with flexibility, reliability, and cost savings.",
// ];

const featuresData = [
  {
    title: "Fast Access to Funds",
    description: "Same-day or next-day settlements to boost your cash flow.",
  },
  // {
  //   title: "More Sales, Fewer Declines",
  //   description: "Smart Trust Card technology keeps customer details up to date and secure."
  // },
  {
    title: "All Payment Types",
    description: "Accept card, mobile, online, and contactless.",
  },
  {
    title: "Trusted & Regulated",
    description: "FCA-regulated and backed by Visa & Mastercard.",
  },
];

// Single card data - no more array
const cardData = {
  title: "Why Choose Trust Card ?",
  description:
    "TailoredPay provides secure, affordable payment processing for high-risk businesses often rejected by traditional banks.",
  price: "£16.99",
  bgColor: "linear-gradient(to left, #FFDA7A, #FFFFFF)",
  sideImge: images.paymentMachineImg,
  respImg: images.paymentMachineImg,
  cornerText: "Get our fastest speeds available",
  cornerCircleColor: "#FF914D",
  uniqueId: "multi-mobile",
  showVideo: false,
};

const TailoredCard = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Container
      sx={{
        maxWidth: "1300px !important",
        marginTop: "40px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          backgroundImage: cardData.bgColor,
          borderRadius: "35px",
          marginTop: "60px",
          padding: "30px 0px 0px 0px",
        }}
      >
        <Grid
          container
          spacing={{ xs: 0, md: 3 }}
          alignItems={{ sm: "flex-start", md: "center" }}
          sx={{
            padding: { xs: "0px 17px 10px", md: "0px 40px" },
          }}
        >
          <Grid
            item
            xs={5.5}
            sm={6}
            textAlign={"center"}
            alignItems={{ xs: "center", sm: "center", md: "flex-end" }}
            display={"flex"}
            justifyContent={{ xs: "center", sm: "center", md: "center" }}
            // paddingTop={{ xs: "5%", sm: "0" }}
            mb={{ sm: 1, md: 3 }}
          >
            <img
              src={isSmallScreen ? cardData.respImg : cardData.sideImge}
              style={{
                width: isSmallScreen ? "90%" : "55%",
                height: isSmallScreen ? "55%" : "320px",
                marginLeft: isSmallScreen ? "0px" : "-20px",
              }}
              alt={cardData.sideImge}
            />
          </Grid>
          <Grid item xs={6.5} sm={6} textAlign={"left"} mb={3}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: { xs: "5px", sm: "10px" },
                background: allColors.royalOrange,
                borderRadius: { xs: "5px", sm: "10px" },
                mb: { sm: 2, md: 5 },
              }}
            >
              <Typography
                sx={{
                  color: allColors.jetBlack,
                  fontFamily: "Raleway",
                  fontWeight: "600",
                  fontSize: { xs: "11px", sm: "11px", md: "30px" },
                }}
              >
                {cardData.title}
              </Typography>
            </Box>
            <Stack spacing={1} marginTop={{ xs: "15px", md: "30px" }}>
              {featuresData.map((feature, index) => (
                <Box
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <img
                    src={icons.tickIcon}
                    alt="tick"
                    style={{
                      width: isSmallScreen ? "15px" : "18px",
                      height: isSmallScreen ? "15px" : "18px",
                    }}
                  />
                  <Box >
                    <Typography
                      sx={{
                        fontFamily: "Raleway",
                        fontSize: { xs: "10px", sm: "10px", md: "15px" },
                        color: allColors.jetBlack,
                        fontWeight: "600",
                        mb: "2px",
                      }}
                    >
                      {feature.title}
                    </Typography>
                    <Typography
                      sx={{
                        fontFamily: "Raleway",
                        fontSize: { xs: "9px", sm: "9px", md: "13px" },
                        color: allColors.jetBlack,
                        fontWeight: "400",
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default TailoredCard;
